module.exports = __webpack_public_path__ + "media/images/flags/32/Puerto-Rico-d74f858193f279f6a73146c1edee9a11.png";